export { SkhemataTestimonial } from './src/SkhemataTestimonial.js';

